import { Observable, map } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { IBatchConfig } from './../../models/batch-config';
import { IGenericResult, ICustomSelect } from 'src/app/models/generic';
import { IBank, IChannel } from './../../models/generic';
import { environment } from 'src/environments/environment';
import { IBeneficiaryType } from 'src/app/models/contract';

@Injectable({
  providedIn: 'root'
})
export class ApiTransferConfigService {
  //baseUrlTRansferBatch = `${environment.apis.transfers.baseUrl}/${environment.apis.transfers.microservices.batch}`;
  //baseUrlTransferConfig = `${environment.apis.transfers.baseUrl}/${environment.apis.transfers.microservices.batchConfig}`;
  baseUrlTransferConfig = `${environment.apis.unified.baseUrl}/${environment.apis.unified.microservices.transferBatchConfig}`;
  //baseUrlReportContract = `${environment.apis.contracts.baseUrl}/${environment.apis.contracts.microservices.report}`;
  baseUrlReportContract = `${environment.apis.unified.baseUrl}/${environment.apis.unified.microservices.contractReport}`;
  //baseUrlManualBatch = `${environment.apis.transfers.baseUrl}/${environment.apis.transfers.microservices.batch}/manual-batch`;
  baseUrlManualBatch = `${environment.apis.unified.baseUrl}/${environment.apis.unified.microservices.transferBatch}/manual-batch`;

  constructor(private _http: HttpClient) { }

  getBank(): Observable<ICustomSelect[]> {
    return this._http
      .get<IGenericResult<IBank[]>>(`${this.baseUrlReportContract}/bank`)
      .pipe(
        map((value: IGenericResult<IBank[]>) => {
          const bankOpts = value.Data.map((bank) => {
            return { id: bank.Name, name: bank.Name };
          });

          return bankOpts as ICustomSelect[];
        })
      );
  }

  getChannel(): Observable<ICustomSelect[]> {
    return this._http
      .get<IGenericResult<IChannel[]>>(`${this.baseUrlReportContract}/channel`)
      .pipe(
        map((value: IGenericResult<IChannel[]>) => {
          const channelOpts = value.Data.map((channel) => {
            return { id: channel.Name, name: channel.Name };
          });

          return channelOpts as ICustomSelect[];
        })
      );
  }

  getBatchStatus(): Observable<ICustomSelect[]> {
    return this._http
      .get<IGenericResult<IChannel[]>>(`${this.baseUrlReportContract}/channel`)
      .pipe(
        map((value: IGenericResult<IChannel[]>) => {
          const channelOpts = value.Data.map((channel) => {
            return { id: channel.Name, name: channel.Name };
          });

          return channelOpts as ICustomSelect[];
        })
      );
  }

  getInvoiceStatus(): Observable<ICustomSelect[]> {
    return this._http
      .get<IGenericResult<string[]>>(
        `${this.baseUrlTransferConfig}/invoice-status`
      )
      .pipe(
        map((value: IGenericResult<string[]>) => {
          const invoiceOpts = value.Data.map((stts) => {
            return { id: stts, name: stts };
          });

          return invoiceOpts as ICustomSelect[];
        })
      );
  }

  getContractStatus(): Observable<ICustomSelect[]> {
    return this._http
      .get<IGenericResult<string[]>>(
        `${this.baseUrlTransferConfig}/contract-status`
      )
      .pipe(
        map((value: IGenericResult<string[]>) => {
          const contractOpts = value.Data.map((stts) => {
            return { id: stts, name: stts };
          });

          return contractOpts as ICustomSelect[];
        })
      );
  }

  getPaymentStatus(): Observable<ICustomSelect[]> {
    return this._http
      .get<IGenericResult<string[]>>(
        `${this.baseUrlTransferConfig}/payment-status`
      )
      .pipe(
        map((value: IGenericResult<string[]>) => {
          const paymentOpts = value.Data.map((stts) => {
            return { id: stts, name: stts };
          });

          return paymentOpts as ICustomSelect[];
        })
      );
  }

  getBeneficiaryTypes(): Observable<ICustomSelect[]> {
    return this._http
      .get<IGenericResult<IBeneficiaryType[]>>(
        `${this.baseUrlReportContract}/beneficiary-type`
      )
      .pipe(
        map((value: IGenericResult<IBeneficiaryType[]>) => {
          const beneficiaryOpts = value.Data.map((bn) => {
            return { id: bn.Name, name: bn.Name };
          });

          return beneficiaryOpts as ICustomSelect[];
        })
      );
  }

  getBeneficiaries(): Observable<ICustomSelect[]> {
    return this._http
      .get<IGenericResult<string[]>>(`${this.baseUrlManualBatch}/beneficiaries`)
      .pipe(
        map((value: IGenericResult<string[]>) => {
          const beneficiaryOpts = value.Data.map((bn) => {
            return { id: bn, name: bn };
          });

          return beneficiaryOpts as ICustomSelect[];
        })
      );
  }

  getBatchConfig(
    typeConfig: 'Manual' | 'Automatic'
  ): Observable<IGenericResult<IBatchConfig[]>> {
    return this._http.get<IGenericResult<IBatchConfig[]>>(
      `${this.baseUrlTransferConfig}?type=${typeConfig}`
    );
  }

  createBatchConfig(config: IBatchConfig): Observable<IBatchConfig> {
    return this._http.post<IBatchConfig>(
      `${this.baseUrlTransferConfig}`,
      config
    );
  }

  updateBatchConfig(config: IBatchConfig): Observable<IBatchConfig> {
    return this._http.put<IBatchConfig>(
      `${this.baseUrlTransferConfig}`,
      config
    );
  }

  deleteBatchConfig(idConfig: string): Observable<any> {
    return this._http.delete<any>(`${this.baseUrlTransferConfig}/${idConfig}`);
  }
}
